'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const MonthlySalesChart = dynamic(() => import('./MonthlySalesChart'), { ssr: false });
const InvoiceTrendChart = dynamic(() => import('./InvoiceTrendChart'), { ssr: false });

export default function DashboardCharts() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 gap-4">
      <div className="lg:col-span-2 bg-card rounded-2xl border border-border card-shadow p-6">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-xl font-700 text-foreground">Monthly Revenue</h2>
            <p className="text-sm text-muted-foreground mt-0.5">FY 2025–26 · All invoices</p>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-2xl font-800 text-foreground font-tabular">—</span>
          </div>
        </div>
        <MonthlySalesChart />
      </div>
      <div className="bg-card rounded-2xl border border-border card-shadow p-6">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-xl font-700 text-foreground">Invoice Trend</h2>
            <p className="text-sm text-muted-foreground mt-0.5">Count by month</p>
          </div>
        </div>
        <InvoiceTrendChart />
      </div>
    </div>
  );
}